export default "__VITE_ASSET__BXXUXdsU__"